import { useIsWorkplaceReviewUXUpdateEnabled } from "@src/appV2/PostShiftReview/hooks/useIsWorkplaceReviewUXUpdateEnabled";
import { type ReviewsViewContext } from "@src/appV2/redesign/ShiftDiscovery/useWorkplaceModalsDataContext";
import { type WorkplaceCommentType } from "@src/appV2/redesign/Workplace/Review/api/useWorkplaceComments";

import { type CommentReactionSource, Reaction } from "../types";
import { WorkplaceReviewCommentLikesButton } from "./LikesButton";
import { ReactionButton } from "./ReactionButton";

interface CommentReactionButtonsProps {
  workerReaction?: Reaction;
  totalLikes: number;
  totalDislikes: number;
  workplaceId: string;
  commentId: string;
  source: CommentReactionSource;
  viewContext: ReviewsViewContext;
  onReactionChanged: (comment: WorkplaceCommentType) => void;
}

export function CommentReactionButtons(props: CommentReactionButtonsProps) {
  const {
    workerReaction,
    totalLikes,
    totalDislikes,
    workplaceId,
    commentId,
    source,
    viewContext,
    onReactionChanged,
  } = props;
  const { isEnabled: isReviewUXUpdateEnabled } = useIsWorkplaceReviewUXUpdateEnabled();

  if (isReviewUXUpdateEnabled) {
    return (
      <>
        <ReactionButton
          reactionType={Reaction.LIKE}
          isActive={workerReaction === Reaction.LIKE}
          count={totalLikes}
          workplaceId={workplaceId}
          commentId={commentId}
          source={source}
          viewContext={viewContext}
          onReactionChanged={onReactionChanged}
        />
        <ReactionButton
          reactionType={Reaction.DISLIKE}
          isActive={workerReaction === Reaction.DISLIKE}
          count={totalDislikes}
          workplaceId={workplaceId}
          commentId={commentId}
          source={source}
          viewContext={viewContext}
          onReactionChanged={onReactionChanged}
        />
      </>
    );
  }

  return (
    <WorkplaceReviewCommentLikesButton
      workplaceId={workplaceId}
      commentId={commentId}
      isLiked={workerReaction === Reaction.LIKE}
      count={totalLikes}
      source={source}
      viewContext={viewContext}
      onLikeChanged={onReactionChanged}
    />
  );
}
